import React, { useState, useEffect, useCallback, useMemo} from "react";
import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  Paper,
  Stack,
  Tab,
  TextField,
  Toolbar,
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Slide,
  useTheme,
  InputAdornment,
} from "@mui/material";
import ViewTransactionsFutureRanges from "../../HelperFunctions/ViewTransactionsFutureRanges";
import ViewTransactionsDayOptions from "../../HelperFunctions/ViewTransactionsDayOptions";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import ViewReport from "../ReportSelecttion/ViewReport";
import DisplayReport from "../ReportSelecttion/DisplayReport";
import MultiCorpPopup from "./MuitiCorpPopup/MultiCorpPopup";
import { useNavigate, useLocation } from "react-router-dom";
import { calculateNextFiscalQuarter, getFiscalYear, getManagementGroupsList, getOTBReport, getCorpPcList, getOTBMemorize, getPrivileges } from "../../API/nimbleAPI";
import { Otbreportpayload } from "../../Payload/OTBReportPayload";
import dayjs from "dayjs";
import { COLORS } from "../../Components/colors";


const PickupDurationEnum = {
  "N/A": 0,
  "1day": 1,
  "3days": 2,
  "7days": 3,
  "14days": 4,
  "30days": 5
};
const defaultDisplaySettings = { textFormat: 'default', negativeFormat: 'normal', showRedNegative: true, withoutCents: false, excludeZero: false };

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const ALL_CORPORATIONS_ID = "010000000000000000000000000000001413";

const ManagementGroupAutocomplete = ({
  options,
  label = "Management Group",
  value,
  onChange,
  onClick,
  ...props
}) => {
  const theme = useTheme();
  return (
    <Autocomplete
      options={Array.isArray(options) ? options : []}
      value={value}
      disableClearable
      getOptionLabel={(option) => {
        if (typeof option === "string") return option;
        return option.DisplayText || option.ManagementGroup || "";
      }}
      isOptionEqualToValue={(option, value) => {
        if (!value) return false;
        const optVal = option.ValueCode || option.ManagementGroup || option;
        const valVal = value.ValueCode || value.ManagementGroup || value;
        return optVal === valVal;
      }}
      {...props}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <li key={option.ValueCode || key} {...rest} style={{ fontSize: "12px" }}>
            {typeof option === "string" ? option : option.DisplayText || option.ManagementGroup || ""}
          </li>
        );
      }}
      onChange={onChange}
      sx={{
        p: 1,
        "& .MuiInputBase-root": {
          height: 40,
          minHeight: 36,
          fontFamily: theme.typography.fontFamily,
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="filled"
          fullWidth
          onClick={onClick}
          sx={{ borderRadius: 1, border: `1px solid ${COLORS.border}` }}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            style: { fontFamily: theme.typography.fontFamily, fontSize: "12px" }
          }}
          InputLabelProps={{ style: { fontFamily: theme.typography.fontFamily, fontSize: "12px" } }}
        />
      )}
    />
  );
};



const CustomizeReport = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const previousState = location.state || {};

  const { beforeToday } = DateRangePicker;
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [multiCorpOpen, setMultiCorpOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [permissionSnackbarOpen, setPermissionSnackbarOpen] = useState(false);
  const [permissionMessage, setPermissionMessage] = useState("");
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [fiscalData, setFiscalData] = useState(null);
  const [privileges, setPrivileges] = useState(null);
  // const [privileges, setPrivileges] = useState(null);

  const [managementGroups, setManagementGroups] = useState([]);
  const [reportPayload, setReportPayload] = useState(() => {
    if (previousState.reportPayload) return previousState.reportPayload;
    const saved = localStorage.getItem("memorizedReportSettings");
    if (saved) {
      try {
        return JSON.parse(saved).reportPayload || Otbreportpayload;
      } catch (e) {
        return Otbreportpayload;
      }
    }
    return Otbreportpayload;
  });

  const [displaySettings, setDisplaySettings] = useState(() => {
    if (previousState.displaySettings) return previousState.displaySettings;
    const saved = localStorage.getItem("memorizedReportSettings");
    if (saved) {
      try {
         return JSON.parse(saved).displaySettings || defaultDisplaySettings;
     } catch (e) { return defaultDisplaySettings; }
    }
    return defaultDisplaySettings;
  });
  
  useEffect(() => {
    const fetchGroups = async () => {
      setLoading(true);
      try {
        const data = await getManagementGroupsList();
        setManagementGroups(data || []);

        const params = new URLSearchParams(location.search);
        const urlCorpID = params.get("corporationID");

        if (data && data.length > 0 && !filters.managementGroup) {
          const defaultGroup = data[0];
          let updates = { managementGroup: defaultGroup };

          if (urlCorpID) {
            try {
              const corpData = await getCorpPcList(defaultGroup.ValueCode);
              if (corpData && Array.isArray(corpData)) {
                const mappedRows = corpData.map((item) => ({
                  id: `${item.PCID}_${item.CorporationID}`,
                  corpId: item.CorporationID,
                  pcId: item.PCID,
                  corpName: item.CorporationName,
                  legalName: item.PCName,
                  brandType: item.PropertyType,
                  service: item.Service,
                  brand: item.Brand,
                  pms: item.PMS,
                }));

                const isSelectAll = urlCorpID === ALL_CORPORATIONS_ID;
                const urlCorpIDs = urlCorpID.split(',').map(id => id.trim());
                const selectedRows = isSelectAll ? mappedRows : mappedRows.filter(r => urlCorpIDs.includes(r.corpId));

                if (selectedRows.length > 0) {
                  updates.corporations = selectedRows.map(r => r.id);
                  updates.corporationIds = [...new Set(selectedRows.map(r => r.corpId))];
                  updates.selectedRows = selectedRows;
                }
              }
            } catch (error) {
              console.error("Error processing URL corporationID:", error);
            }
          }
          setFilters(prev => ({ ...prev, ...updates }));
        }
      } finally {
        setLoading(false);
      }
    };
    fetchGroups();
  }, []);

  const [filters, setFilters] = useState(previousState.filters || {
    managementGroup: null,
    corporations: null,
    corporationIds: [],
    viewTransactionRange: "Next 30 Days",
    pickupDuration: "7days",
  });

  useEffect(() => {
    const fetchPrivileges = async () => {
      const params = new URLSearchParams(location.search);
      const userId = params.get('userId') || params.get('userID');
      const menuId = params.get('menuId') || params.get('menuID');

      if (!userId || !menuId) return;

      try {
        const res = await getPrivileges({ UserID: userId, MenuIds: menuId });
        const details = res?.Details?.[0];
        if (details) {
          setPrivileges({
            create: Boolean(details.Create),
            update: Boolean(details.Update),
            view: Boolean(details.View),
            delete: Boolean(details.Delete)
          });
        }
      } catch (error) {
      }
    };

    fetchPrivileges();
  }, [location.search]);

  const canUpdate = privileges ? privileges.update : true;
  const canView = privileges ? (privileges.view || privileges.update || privileges.create) : true;
  const notifyNoPermission = useCallback((type = "update") => {
    const msg = type === "create"
      ? "You don't have create permission."
      : "You don't have update permission.";
    setPermissionMessage(msg);
    setPermissionSnackbarOpen(true);
  }, []);

  const isMultipleCorporations = (filters?.corporationIds?.length || 0) > 1;
  const futureRanges = useMemo(() => ViewTransactionsFutureRanges(fiscalData, isMultipleCorporations), [fiscalData, isMultipleCorporations]);
  const dayRanges = ViewTransactionsDayOptions();

  const defaultRange = useMemo(() => futureRanges.find((opt) => opt.date === "Next 30 Days"), [futureRanges]);
  const [dateRange, setDateRange] = useState(() => {
    if (previousState.dateRange) {
      return previousState.dateRange.map((d) => new Date(d));
    }
    return [defaultRange.actualValue.start, defaultRange.actualValue.end];
  });

  useEffect(() => {
    const fetchMemorized = async () => {
      if (!canUpdate) return;
      if (location.state) return;

      const params = new URLSearchParams(location.search);
      const userId = params.get('userId') || params.get('userID');
      const menuId = params.get('menuId') || params.get('menuID');

      if (userId && menuId) {
        try {
          const res = await getOTBMemorize({ UserId: userId, MenuId: menuId });
          if (Array.isArray(res) && res.length > 0) {
            const memorized = res[0];

            setDisplaySettings({
              textFormat: memorized.DisplayTextFormat === 2 ? 'upper' : (memorized.DisplayTextFormat === 1 ? 'lower' : 'default'),
              negativeFormat: memorized.ShowNegFig === 1 ? 'parentheses' : (memorized.ShowNegFig === 2 ? 'trailing' : 'normal'),
              showRedNegative: memorized.InRed,
              withoutCents: memorized.WOCents,
              excludeZero: memorized.ExcludeZero
            });

            if (memorized.CustomizeString) {
              setReportPayload(prev => {
                const newPayload = { ...Otbreportpayload };
                const customizeStringLower = memorized.CustomizeString.toLowerCase();
                Object.keys(newPayload).forEach(key => {
                  if (typeof newPayload[key] === 'boolean') {
                    newPayload[key] = customizeStringLower.includes(`%${key.toLowerCase()}%`);
                  }
                });
                newPayload.PickUpDays = memorized.PickUpdays;
                return newPayload;
              });
            }

            const viewTransTypeMap = {
              1: "Next 7 Days",
              2: "Next 14 Days",
              3: "Next 30 Days",
              4: "Next 45 Days",
              5: "Next 60 Days",
              6: "Next 90 Days",
              7: "Next 120 Days",
              8: "Next 6 Months",
              9: "Next Fiscal Quarter",
              10: "Next 9 Months",
              11: "Next 12 Months (1 Year Forecast)",
              12: "Custom Date Range"
            };

            const pickupLabels = { 1: "1day", 2: "3days", 3: "7days", 4: "14days", 5: "30days" };
            const viewLabel = viewTransTypeMap[memorized.ViewTransType] || "Next 30 Days";
            const pickupLabel = pickupLabels[memorized.PickUpdays] || "7days";

            setFilters(prev => ({ ...prev, viewTransactionRange: viewLabel, pickupDuration: pickupLabel }));

            if (memorized.ViewTransType === 12 && memorized.CustomizeString) {
              const fromMatch = memorized.CustomizeString.match(/%ShortFromDate:([^%]+)%/);
              const toMatch = memorized.CustomizeString.match(/%ShortToDate:([^%]+)%/);
              if (fromMatch && toMatch) {
                setDateRange([new Date(fromMatch[1]), new Date(toMatch[1])]);
              }
            } else {
              const rangeOption = futureRanges.find(opt => opt.date === viewLabel);
              if (rangeOption && rangeOption.actualValue.start) {
                setDateRange([rangeOption.actualValue.start, rangeOption.actualValue.end]);
              }
            }
          }
        } catch (e) { console.error(e); }
      }
    };
    fetchMemorized();
  }, [canUpdate, location.state, location.search]);

  useEffect(() => {
    if (!canUpdate && privileges) {
      setReportPayload({ ...Otbreportpayload });
      setDisplaySettings({ ...defaultDisplaySettings });
      setFilters((prev) => ({
        ...prev,
        viewTransactionRange: "Next 30 Days",
        pickupDuration: "7days",
      }));
      if (defaultRange?.actualValue?.start && defaultRange?.actualValue?.end) {
        setDateRange([defaultRange.actualValue.start, defaultRange.actualValue.end]);
      }
    }
  }, [canUpdate, privileges, defaultRange, defaultDisplaySettings]);

  // useEffect(() => {
  //   if ((filters?.corporationIds?.length || 0) !== 1) {
  //     setFiscalData(null);
  //   }
  // }, [filters?.corporationIds]);

  const fetchFiscalData = useCallback(async (corpId) => {
    setLoading(true);
    try {
      const res = await getFiscalYear({ corpId: corpId });
      const normalized = Array.isArray(res) ? res[0] : res;
      setFiscalData(normalized || null);
      return normalized || null;
    } catch (error) {
      console.error("Error fetching fiscal year data:", error);
      setFiscalData(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if ((filters?.corporationIds?.length || 0) === 1) {
      fetchFiscalData(filters.corporationIds[0]);
    } else {
      setFiscalData(null);
    }
  }, [filters?.corporationIds, fetchFiscalData]);



  const handleClear = async () => {
    if (!canUpdate) {
      notifyNoPermission("update");
      return;
    }
    const defaultGroup = managementGroups.length > 0 ? managementGroups[0] : null;
    let newFilters = {
      managementGroup: defaultGroup,
      corporations: null,
      corporationIds: [],
      viewTransactionRange: "Next 30 Days",
      pickupDuration: "7days",
      selectedRows: []
    };

    const params = new URLSearchParams(location.search);
    const urlCorpID = params.get("corporationID");

    if (urlCorpID && defaultGroup) {
      try {
        setLoading(true);
        const corpData = await getCorpPcList(defaultGroup.ValueCode);
        if (corpData && Array.isArray(corpData)) {
          const mappedRows = corpData.map((item) => ({
            id: `${item.PCID}_${item.CorporationID}`,
            corpId: item.CorporationID,
            pcId: item.PCID,
            corpName: item.CorporationName,
            legalName: item.PCName,
            brandType: item.PropertyType,
            service: item.Service,
            brand: item.Brand,
            pms: item.PMS,
          }));

          const isSelectAll = urlCorpID === ALL_CORPORATIONS_ID;
          const urlCorpIDs = urlCorpID.split(',').map(id => id.trim());
          const selectedRows = isSelectAll ? mappedRows : mappedRows.filter(r => urlCorpIDs.includes(r.corpId));

          if (selectedRows.length > 0) {
            newFilters.corporations = selectedRows.map(r => r.id);
            newFilters.corporationIds = [...new Set(selectedRows.map(r => r.corpId))];
            newFilters.selectedRows = selectedRows;
          }
        }
      } catch (error) {
        console.error("Error processing URL corporationID on clear:", error);
      } finally {
        setLoading(false);
      }
    }

    setFilters(newFilters);

    if (defaultRange) {
      setDateRange([defaultRange.actualValue.start, defaultRange.actualValue.end]);
    }

    setReportPayload({ ...Otbreportpayload });
    setDisplaySettings({ ...defaultDisplaySettings }); };

  const handleGenerate = useCallback(async (filtersOverride) => {
    const activeFilters = (filtersOverride && !filtersOverride.preventDefault) ? filtersOverride : filters;



    if (!activeFilters.corporations || activeFilters.corporations.length === 0) {
      setSnackbarOpen(true);
      return;
    }
    setLoading(true);

    const pickupValue = PickupDurationEnum[activeFilters.pickupDuration] !== undefined
      ? PickupDurationEnum[activeFilters.pickupDuration]
      : activeFilters.pickupDuration;

    const payload = {
      ...reportPayload,
      CorporationIDLst: Array.isArray(activeFilters.corporationIds) && activeFilters.corporationIds.length > 0 ? activeFilters.corporationIds.join(",") : "0",
      PCIdLst: Array.isArray(activeFilters.selectedRows) && activeFilters.selectedRows.length > 0 ? activeFilters.selectedRows.filter(row => row.pcId).map(row => (typeof row.pcId === 'string' && row.pcId.startsWith("0x") ? row.pcId.slice(2) : row.pcId)).join(",") : "",
      ShortFromDate: dateRange && dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : null,
      ShortToDate: dateRange && dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : null,
      PickUpDays: pickupValue || 0,
    };

    try {
      const data = await getOTBReport(payload);

      const urlParams = new URLSearchParams();
      const currentParams = new URLSearchParams(location.search);
      const authID = currentParams.get('authID');
      const userId = currentParams.get('userId') || currentParams.get('userID');
      const menuId = currentParams.get('menuId') || currentParams.get('menuID');
      const urlInfo = currentParams.get('urlInfo');

      if (urlInfo) urlParams.set('urlInfo', urlInfo);
      if (userId) urlParams.set('userId', userId);
      if (menuId) urlParams.set('menuId', menuId);
      if (payload.CorporationIDLst) urlParams.set('corporationID', payload.CorporationIDLst);
      if (authID) urlParams.set('authID', authID);

      const searchString = urlParams.toString();

      navigate(`/OTB-report?${searchString}`, {
        state: {
          reportData: data || [],
          metaData: payload,
          filters: activeFilters,
          dateRange,
          reportPayload,
          displaySettings,
        },
      });
    } catch (error) {
      console.error("Error generating report:", error);
    } finally {
      setLoading(false);
    }
  }, [filters, dateRange, reportPayload, displaySettings, navigate, canView, notifyNoPermission]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.altKey && event.key.toLowerCase() === 'g') {
        if (!multiCorpOpen) {
          event.preventDefault();
          handleGenerate();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleGenerate, multiCorpOpen]);

  return (
    <Dialog
      fullScreen
      open={open}
      disableEnforceFocus
      PaperProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          zIndex: 1300
        }
      }}
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={loading}
      >
        <CircularProgress size={50} sx={{ color: COLORS.loader }} />
      </Backdrop>
      <AppBar elevation={0} sx={{ bgcolor: COLORS.bgWhite, position: 'relative', flexShrink: 0 }}>
        <Toolbar
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button
            variant="contained"
            className="create-budget-btn"
            size="small"
            onClick={handleClear}
            sx={{ height: 28, fontSize: "12px", width: 100 }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            className="create-budget-btn"
            size="small"
            onClick={handleGenerate}
            sx={{ height: 28, fontSize: "12px", width: 100 }}
          >
            Generate
          </Button>
        </Toolbar>
      </AppBar>

      <DialogContent sx={{ p: 0.5, flex: 1, overflow: 'visible', overflowY: 'auto' }}>
        <Stack
          direction="row"
          gap={3}
          height={"100%"}
        >
          <Stack
            // component={Paper}
            gap={2}
            elevation={0}
            sx={{
              // flex: 1.5,
              minWidth: 320,
              maxWidth: 360,
              border: `1px solid ${COLORS.borderMedium}`,
              p: 1,
              overflowY: "auto",
            }}
          >
            <ManagementGroupAutocomplete
              options={managementGroups}
              value={filters.managementGroup}
              onChange={(e, newValue) =>
                canUpdate
                  ? setFilters((prev) => ({
                    ...prev,
                    managementGroup: newValue,
                    corporations: [],
                    corporationIds: [],
                    selectedRows: []
                  }))
                  : notifyNoPermission("update")
              }
            />

            <ManagementGroupAutocomplete
              label="Corporations"
              options={managementGroups}
              value={
                Array.isArray(filters.corporations) && filters.corporations.length > 0
                  ? `${filters.corporations.length} Corporations Selected`
                  : null
              }
              onChange={() => { }}
              onClick={() => canView ? setMultiCorpOpen(true) : notifyNoPermission("update")}
              freeSolo
              readOnly
            />

            <ManagementGroupAutocomplete
              label="View Transactions"
              options={futureRanges.map((opt) => opt.date)}
              value={filters.viewTransactionRange}
              onChange={async (e, newValue) => {
                if (!canUpdate) {
                  notifyNoPermission("update");
                  return;
                }
                setFilters((prev) => ({
                  ...prev,
                  viewTransactionRange: newValue,
                }));

                if (!newValue) return;

                const isFiscalLabel = newValue === "Next Fiscal Quarter" || newValue === "Next Financial Quarter";
                if (isFiscalLabel) {
                  const corpIds = filters?.corporationIds || [];
                  const corpId = corpIds.length === 1 ? corpIds[0] : null;

                  if (corpId) {
                    const fiscal = await fetchFiscalData(corpId);
                    const nextFiscal = calculateNextFiscalQuarter(fiscal, corpIds.length > 1);
                    if (nextFiscal) {
                      setDateRange([new Date(nextFiscal.startDate), new Date(nextFiscal.endDate)]);
                      return;
                    }
                  }

                  setDateRange([
                    dayjs().add(1, "quarter").startOf("quarter").toDate(),
                    dayjs().add(1, "quarter").endOf("quarter").toDate(),
                  ]);
                  return;
                }

                const selected = futureRanges.find((opt) => opt.date === newValue);
                if (!selected) return;

                if (selected.date === "Custom Date Range") {
                  setDateRange(null);
                  return;
                }

                setDateRange([selected.actualValue.start, selected.actualValue.end]);
              }}
            />

            <Box sx={{ p: 1, position: "relative" }}>
              <TextField
                label="Date Range"
                variant="filled"
                fullWidth
                value={
                  dateRange && dateRange[0] && dateRange[1]
                    ? `${dayjs(dateRange[0]).format("MM/DD/YYYY")} - ${dayjs(dateRange[1]).format("MM/DD/YYYY")}`
                    : ""
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                  style: { fontFamily: theme.typography.fontFamily, fontSize: "12px" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <ArrowDropDownIcon style={{ fontSize: "20px", color: COLORS.iconLight }} />
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  style: {
                    fontFamily: theme.typography.fontFamily,
                    fontSize: "12px",
                    color: isDatePickerOpen ? theme.palette.primary.main : undefined,
                  },
                  shrink: isDatePickerOpen ? true : undefined,
                }}
                sx={{
                  borderRadius: 1,
                  border: `1px solid ${COLORS.border}`,
                  "& .MuiInputBase-root": {
                    height: 40,
                    minHeight: 36,
                  },
                }}
              />
              <DateRangePicker
                size="sm"
                shouldDisableDate={beforeToday()}
                format="MM/dd/yyyy"
                character=" - "
                value={dateRange}
                onChange={(value) => {
                  if (!canUpdate) {
                    notifyNoPermission("update");
                    return;
                  }
                  setDateRange(value);
                  setFilters((prev) => ({
                    ...prev,
                    viewTransactionRange: "Custom Date Range",
                  }));
                }}
                onOpen={() => canUpdate ? setIsDatePickerOpen(true) : notifyNoPermission("update")}
                onClose={() => setIsDatePickerOpen(false)}
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  zIndex: 1,
                }}
                cleanable={true}
                placement="rightStart"
                preventOverflow
                container={() => document.body}
                ranges={[]}
              />

            </Box>
            <ManagementGroupAutocomplete
              label="Select Pickup Duration"
              options={dayRanges.map((opt) => opt.label)}
              value={filters.pickupDuration}
              onChange={(e, newValue) =>
                canUpdate
                  ? setFilters((prev) => ({
                    ...prev,
                    pickupDuration: newValue,
                  }))
                  : notifyNoPermission("update")
              }
            />
          </Stack>

          <Box
            sx={{
              border: `1px solid ${COLORS.borderMedium}`,
              height: "100%",
              width: "100%",
              overflow: "auto"
            }}
          >
            <TabContext value={value}>
              <Box>
                <TabList
                  onChange={handleChange}
                  sx={{
                    textTransform: "none",
                    alignItems: "center",
                    maxHeight: 30,
                    minHeight: 30,
                    fontSize: "13px",
                    "& .MuiTab-root": {
                      fontSize: "13px",
                      textTransform: "none",
                      px: 6,
                      py: 1,
                      bgcolor: COLORS.secondary,
                      color: COLORS.textWhite,

                      minHeight: 30,
                    },
                    "& .Mui-selected": {
                      fontSize: "13px",
                      textTransform: "none",
                      bgcolor: COLORS.bgLight,
                      color: COLORS.secondaryText,
                    },
                    "& .MuiTab-root:last-of-type": {
                      borderRadius: "3px 0px 5px 0", // top-left, top-right, bottom-right, bottom-left
                    },
                  }}
                >
                  <Tab label="View" value="1" />
                  <Tab label="Display" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ width: "100%" }}>
                <ViewReport
                  pickupDuration={filters.pickupDuration}
                  reportPayload={reportPayload}
                  setReportPayload={setReportPayload}
                  selectedPropCount={filters.corporations?.length || 0}
                  canUpdate={canUpdate}
                  onPermissionDenied={() => notifyNoPermission("update")}
                />
              </TabPanel>
              <TabPanel value="2">
                <DisplayReport
                  displaySettings={displaySettings}
                  setDisplaySettings={setDisplaySettings}
                  canUpdate={canUpdate}
                  onPermissionDenied={() => notifyNoPermission("update")}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </Stack>
        <MultiCorpPopup
          open={multiCorpOpen}
          onClose={() => setMultiCorpOpen(false)}
          onApply={(data, isGenerate) => {
            if (!canView) {
              notifyNoPermission("update");
              return;
            }
            const newFilters = {
              ...filters,
              corporations: data.pcIds,
              corporationIds: data.corpIds,
              selectedRows: data.selectedRows
            };
            setFilters(newFilters);
            if (isGenerate) {
              handleGenerate(newFilters);
            }
          }}
          managementGroups={managementGroups}
          currentManagementGroup={filters.managementGroup}
          onManagementGroupChange={(newValue) => {
            setFilters((prev) => ({
              ...prev,
              managementGroup: newValue,
              corporations: [],
              corporationIds: [],
              selectedRows: []
            }));
          }}
          initialSelectedIds={filters.corporations}
        />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          TransitionComponent={SlideTransition}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={() => setSnackbarOpen(false)} severity="error" variant="filled" sx={{ width: "100%", fontSize: '12px' }}>
            Please select at least one corporation
          </Alert>
        </Snackbar>
        <Snackbar
          open={permissionSnackbarOpen}
          autoHideDuration={3000}
          TransitionComponent={SlideTransition}
          onClose={() => setPermissionSnackbarOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={() => setPermissionSnackbarOpen(false)} severity="error" variant="filled" sx={{ width: "100%", fontSize: '12px' }}>
            {permissionMessage}
          </Alert>
        </Snackbar>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(CustomizeReport);
